import React from "react";
import "./CardLoader.css";

export default function CardLoader() {
  return (
<div className="loader-container">
<div class="spinner">
  <span>L</span>
  <span>O</span>
  <span>A</span>
  <span>D</span>
  <span>I</span>
  <span>N</span>
  <span>G</span>
</div>
</div>
  );
}
